import { createFileRoute } from '@tanstack/react-router';

import { Page } from '@common/ui/Page';

import { Profile } from '@widgets/profile/Profile';

export const Route = createFileRoute('/profile/')({
  component: Component,
});

export default function Component() {
  return (
    <>
      <Page style={{ paddingLeft: 0, paddingRight: 0 }}>
        <Profile />
      </Page>
    </>
  );
}
